var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIssue = function SvgIssue(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 13.66594,
    x2: 86,
    y2: 157.224136,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 85.994629,
    y1: 13.66594,
    x2: 85.994629,
    y2: 157.224136,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 69.875,
    y1: 13.66594,
    x2: 69.875,
    y2: 157.224136,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 102.125,
    y1: 13.66594,
    x2: 102.125,
    y2: 157.224136,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 118.25,
    y1: 13.66594,
    x2: 118.25,
    y2: 157.224136,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 53.75,
    y1: 13.66594,
    x2: 53.75,
    y2: 157.224136,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 113.028191,
    y1: 51.74781,
    x2: 113.028191,
    y2: 107.002808,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 58.971809,
    y1: 51.74781,
    x2: 58.971809,
    y2: 107.002808,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9114965"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 24.21875 39.84375 L 25.78125 39.84375 L 25.78125 46.09375 L 24.21875 46.09375 Z M 24.21875 39.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 44.21875 33.308594 L 27.046875 5.871094 C 26.632812 5.128906 25.867188 4.6875 25 4.6875 C 24.140625 4.6875 23.382812 5.121094 22.964844 5.851562 L 5.761719 33.339844 C 5.320312 34.121094 5.382812 35.054688 5.917969 35.773438 C 6.476562 36.527344 7.398438 36.863281 8.328125 36.660156 L 24.820312 32.992188 C 24.9375 32.964844 25.0625 32.964844 25.179688 32.992188 L 41.671875 36.660156 C 41.851562 36.699219 42.03125 36.71875 42.207031 36.71875 C 42.945312 36.71875 43.632812 36.378906 44.082031 35.773438 C 44.617188 35.054688 44.675781 34.121094 44.21875 33.308594 Z M 7.988281 35.132812 C 7.511719 35.242188 7.242188 34.9375 7.171875 34.84375 C 7.09375 34.738281 6.929688 34.453125 7.105469 34.140625 L 24.21875 6.792969 L 24.21875 31.523438 Z M 42.828125 34.84375 C 42.757812 34.9375 42.488281 35.242188 42.011719 35.132812 L 25.78125 31.523438 L 25.78125 6.792969 L 42.878906 34.109375 C 43.070312 34.453125 42.90625 34.738281 42.828125 34.84375 Z M 42.828125 34.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 19.53125 38.28125 L 21.09375 38.28125 L 21.09375 42.96875 L 19.53125 42.96875 Z M 19.53125 38.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 28.90625 38.28125 L 30.46875 38.28125 L 30.46875 42.96875 L 28.90625 42.96875 Z M 28.90625 38.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 33.59375 36.71875 L 35.15625 36.71875 L 35.15625 41.40625 L 33.59375 41.40625 Z M 33.59375 36.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 14.84375 36.71875 L 16.40625 36.71875 L 16.40625 41.40625 L 14.84375 41.40625 Z M 14.84375 36.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 27.34375 15.066406 L 27.34375 29.15625 C 27.34375 29.339844 27.472656 29.5 27.648438 29.539062 L 37.894531 31.816406 C 38.230469 31.890625 38.492188 31.523438 38.308594 31.230469 L 28.066406 14.859375 C 27.855469 14.527344 27.34375 14.675781 27.34375 15.066406 Z M 27.34375 15.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 21.933594 14.859375 L 11.691406 31.230469 C 11.507812 31.523438 11.765625 31.894531 12.105469 31.816406 L 22.351562 29.539062 C 22.527344 29.5 22.65625 29.339844 22.65625 29.15625 L 22.65625 15.066406 C 22.65625 14.675781 22.144531 14.527344 21.933594 14.859375 Z M 21.933594 14.859375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIssue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/issue.0bc4847c.svg";
export { ForwardRef as ReactComponent };